import * as countryCodes from 'country-codes-list';
import {
  DeliveryDestinationCode,
  DeliveryDestinations,
} from '../../../common/deliveryDestinations';
import { Translations } from '../../../common/getTranslatedValue';

export function getLanguageTranslation(
  value: Translations | string | null | undefined,
  lang: string,
): string | null {
  if (value == null) return null;
  if (typeof value === 'string') {
    return value.trim() ? value : null;
  }

  const text = value[lang.toUpperCase()] ?? value[lang] ?? value[lang.toLowerCase()];
  if (typeof text !== 'string' || !text.trim()) return null;
  return text;
}

export function getTranslationLanguageDisplay(lang: string): { code: string; flag: string; name: string } {
  const code = lang.toUpperCase();
  if (code in DeliveryDestinations) {
    const destination = DeliveryDestinations[code as DeliveryDestinationCode];
    return { code, flag: destination.flag, name: destination.name };
  }

  const countryCode = code === 'EN' ? 'GB' : code;
  const country = countryCodes.findOne('countryCode', countryCode);
  return {
    code,
    flag: country?.flag ?? code,
    name: country?.countryNameEn ?? code,
  };
}
